function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8889 12.8889C24.8889 19.5163 19.5163 24.8889 12.8889 24.8889C6.2615 24.8889 0.888916 19.5163 0.888916 12.8889C0.888916 6.2615 6.2615 0.888916 12.8889 0.888916C19.5163 0.888916 24.8889 6.2615 24.8889 12.8889ZM2.57054 12.8889C2.57054 18.5876 7.19023 23.2073 12.8889 23.2073C18.5876 23.2073 23.2073 18.5876 23.2073 12.8889C23.2073 7.19023 18.5876 2.57054 12.8889 2.57054C7.19023 2.57054 2.57054 7.19023 2.57054 12.8889Z",
  fill: "#FFAE64"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0556 16.1668L7.55558 12.6668L6.38892 13.8335L11.0556 18.5002L20.0556 9.50016L18.8889 8.3335L11.0556 16.1668Z",
  fill: "#FFAE64"
});

var SvgSuccessWithNo = function SvgSuccessWithNo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessWithNo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-with-no.abee507e.svg";
export { ForwardRef as ReactComponent };